







import {Component, Mixins} from 'vue-mixin-decorator';
import {getModule} from 'vuex-module-decorators';

import {Notify} from '@/utils/Notify';

import LoraForwardersStore from '@/store/lora/LoraForwarders.store';

import {BaseComponent} from '@/mixins/BaseComponent';
import LoraForwarderUdpStatus from '@/components/Lora/Forwarder/Udp/LoraForwarderUdpStatus.vue';
import LoraForwarderChirpStackStatus from '@/components/Lora/Forwarder/ChirpStack/LoraForwarderChirpStackStatus.vue';
import LoraForwarderBasicStationStatus
  from '@/components/Lora/Forwarder/BasicStation/LoraForwarderBasicStationStatus.vue';

@Component({
  components: {LoraForwarderUdpStatus, LoraForwarderChirpStackStatus, LoraForwarderBasicStationStatus},
})
export default class LoraForwarderStatus extends Mixins<BaseComponent>(BaseComponent) {
  private loraForwardersStore: LoraForwardersStore = getModule(LoraForwardersStore, this.$store);

  private forwardersStatusComponents = {
    'udp-packet-forwarder': 'lora-forwarder-udp-status',
    'chirpstack-gateway-bridge': 'lora-forwarder-chirp-stack-status',
    'lora-basic-station': 'lora-forwarder-basic-station-status',
  };

    private async mounted() {
      await this.refresh();
    }

    private async refresh() {
      this.logger.info(`Getting active forwarder...`);
      this.setLoading();

      try {
        await this.loraForwardersStore.fetchActiveForwarder();
      } catch (error) {
        Notify.Error(this.logger, `Could not get active forwarder`, error);
      } finally {
        this.setLoaded();
      }
    }
  }
